<template>
  <vue-final-modal
    v-slot="{close}"
    :classes="'modal-container ' + (dockPosition ? 'docked ' : '') + classDetail"
    content-class="modal-content "
    v-bind="$attrs"
    :esc-to-close="true"
    :drag="isDrag"
    :resize="resize"
    :content-style="styles"
    :click-to-close="false"
    :click-to-tab-new="false"
    drag-selector=".modal__title"
    class="ms-help-popup"
    :transition="{
      'enter-active-class': '.3s cubic-bezier(.25,.8,.25,1)',
      'enter-class': 'translate-y-full',
      'enter-to-class': 'translate-y-0',
      'leave-active-class': 'transition duration-200 ease-in-out transform',
      'leave-to-class': 'translate-y-full',
      'leave-class': 'translate-y-0',
    }"
  >
    <div class="modal__title" :class="[{modal__drag: isDrag}, classTitle]">
      <div class="title-left flex-between g10">
        <slot :close="close" name="left-title"></slot>
        <div
          v-if="isShowBack"
          class="full-tab-childB icon24 icon-back-white"
          v-tooltip="MSConstant.TooltipShortkey.Back"
          @click="backClick()"
        ></div>
        <span class="title" @click="redirectClick">
          <slot name="title">{{ title }}</slot>
          <slot name="sub-title"></slot>
        </span>
        <slot name="content-title"></slot>
      </div>
      <div class="title-right">
        <slot name="icon"></slot>

        <div
          class="button icon24 icon-open-tab-new mr-1"
          v-tooltip="MSConstant.TooltipShortkey.TabNew"
          @click="tabnewClick(close)"
        ></div>
        <div
          v-tooltip="MSConstant.TooltipShortkey.Esc"
          class="button icon24 icon-exit-help"
          shortkey-target="Close"
          @click="closeClick(close)"
        ></div>
      </div>
    </div>
    <div class="modal__content flex-column flex1">
      <span v-shortkey="defaultShortKey" class="popup-shortkey" @shortkey="shortkeyAction"></span>
      <slot name="content" :close="close"></slot>
    </div>
    <div v-if="$slots['footer']" class="modal_footer_help">
      <slot name="footer" :close="close"></slot>
    </div>
  </vue-final-modal>
</template>

<script>
import {shortkeyStatusbar} from '@/mixins/common/shortkeyStatusbar';
import {MSConstant} from '@/commons/wildcards';
export default {
  name: 'MsHelpPopup',
  mixins: [shortkeyStatusbar],
};
</script>
<script setup>
import {defineProps, computed, getCurrentInstance, watchEffect, onMounted, onUnmounted} from 'vue';
const {proxy} = getCurrentInstance();
const emit = defineEmits(['shortkeyAction', 'redirectClick']);
const props = defineProps({
  dragable: {
    type: Boolean,
    default: true,
  },
  resize: {
    type: Boolean,
    default: false,
  },
  width: {
    type: Number,
    default: 0,
  },
  height: {
    type: Number,
    default: 0,
  },
  title: {
    type: String,
    default: '',
  },
  maximum: {
    type: Boolean,
    default: false,
  },
  /**
   * Có hiển thị icon maxixum không
   */
  maximumable: {
    type: Boolean,
    default: false,
  },
  params: {
    type: Object,
    default: () => {},
  },
  classTitle: {
    type: String,
    default: '',
  },
  dockPosition: {
    type: String,
    default: null,
  },

  isShowBack: {
    type: Boolean,
    default: false,
  },
  /**
   * Định nghĩa shortKey
   */
  shortkey: {
    default: null,
    type: [String, Object],
  },

  /**
   * class root
   */
  classDetail: {
    default: null,
    type: String,
  },
  customClickClose: {
    default: null,
    type: Function,
  },
  customClickTabNew: {
    default: null,
    type: Function,
  },
  customClickBack: {
    default: null,
    type: Function,
  },
});

const shortKey = {
  Close: ['esc'], // Đóng
  Save: ['ctrl', 's'], // Cất
  SaveAndAdd: ['ctrl', 'shift', 's'], // Cất và thêm
  Help: ['f1'], // Giúp
  Print: ['ctrl', 'p'], // IN
  Maximum: ['ctrl', 'space'], // phóng to thu nhỏ form
  QuickSelect: ['f3'], // chọn nhanh
  ArrowLeft: ['alt', 'b'], // back chứng từ
  ArrowRight: ['alt', 'n'], // next chứng từ
  Postpone: ['ctrl', 'u'], // hoãn
  View: ['ctrl', 'o'], // xem
  Edit: ['ctrl', 'e'], // sửa
  Refresh: ['ctrl', 'r'], // load lại grid
  Delete: ['ctrl', 'd'], // xóa
  Duplicate: ['ctrl', 'shift', 'c'], // nhân bản
  InsertRowGrid: ['ctrl', 'insert'],
  DeleteRowGrid: ['ctrl', 'del'],
  Add: ['ctrl', '1'],
  Cancel: ['ctrl', 'h'],
  Quit: ['ctrl', 'q'],
  ViewAccount: ['ctrl', '3'], // Xem số dư tài khoản
  Search: ['f2'], // Tìm kiếm chứng từ
  ShowSettingLayout: ['ctrl', '*'], //Xem thiết lập layout
};

const defaultShortKey = computed(() => {
  if (props.shortkey) return props.shortkey;
  return shortKey;
});

const isDrag = computed(() => {
  if (props.maximum) return false;

  if (props.dockPosition) return false;
  return props.dragable !== false;
});

const styles = computed(() => {
  const style = {};
  if (props.width) style.width = `${props.width}px`;

  if (props.height) style.height = `${props.height}px`;

  if (props.maximum) {
    style.width = '100%';
    style.height = '100vh';
    style.top = 0;
    style.left = 0;
  }

  if (props.dockPosition) {
    style.height = '100vh';
    switch (props.dockPosition) {
      case 'left':
        style.left = 0;
        break;
      case 'right':
        style.right = 0;
        break;
    }
  }
  return style;
});

/**
 * Push el để xử lý shortkey cho view
 */
onMounted(() => {
  proxy.$ms.commonFn.shortkeyPushView(proxy.$el);
});

/**
 * Loại bỏ el dùng cho shortkey
 */
onUnmounted(() => {
  proxy.$ms.commonFn.shortkeyPopView(proxy.$el);
});
/**
 * emit event click title
 * bnanh 01.07.2022
 */
const redirectClick = () => {
  emit('redirectClick');
};

const maximumClick = () => {
  proxy.$emit('update:maximum', !props.maximum);
};

const tabnewClick = async () => {
  if (props.customClickTabNew && typeof props.customClickTabNew === 'function') {
    await props.customClickTabNew();
  }
};

const closeClick = async close => {
  if (props.customClickClose && typeof props.customClickClose === 'function') {
    await props.customClickClose();
  }
  close();
};

const backClick = async () => {
  if (props.customClickBack && typeof props.customClickBack === 'function') {
    await props.customClickBack();
  }
};

/**
 * emit event phím tắt
 */
const shortkeyAction = e => {
  const me = this;
  switch (e.srcKey) {
    default:
      emit('shortkeyAction', e);
      break;
  }
};
</script>

<style scoped lang="scss">
:deep(.modal-container) {
  display: flex;
  justify-content: center;
  align-items: center;
  &.docked {
    justify-content: unset;
  }
}
:deep(.modal-content) {
  position: absolute;
  display: flex;
  flex-direction: column;
  border-radius: 0.25rem;
  background: #fff;
}
.modal__content {
  flex: 1;
}
.modal__title {
  padding: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: var(--brand-color-6);
  &:hover {
    cursor: move;
  }
  .title {
    font-size: $ms-popup__title-font-size;
    font-weight: $font-weight-bold;
    color: #fff;
  }
  .button {
    cursor: pointer;
    display: inline-block;
    padding: 10px 8px;
  }

  .title-right {
    display: flex;
    align-items: center;
  }
}
.modal_footer_help {
  height: $ms-popup__footer-height;
  padding: 0 16px;
  display: flex;
  background-color: #fff;
  border-top: 1px solid #cdcdcd;
  @include for_breakpoint(desktop-xl) {
    height: $ms-popup__footer-height-xl;
  }
}
.modal_footer_help1 {
  height: 300px;
  padding: 0 16px;
  display: flex;
  background-color: #fff;
  border-top: 1px solid #cdcdcd;
  @include for_breakpoint(desktop-xl) {
    height: 300px;
  }
}
.modal__close {
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
}
.g10 {
  gap: 20px;
}
</style>
